export enum EBetSuccessModalActions {
  doBetSuccess = 'doBetSuccess'
}
